import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { call, put, delay, select } from 'redux-saga/effects';
import { reloadStashStream } from '../actions';
import { getCurrentFolderId } from '../selectors';
import { uploadFile } from '../../redux/uploads/actions';
export function* uploadFileHandler(payload) {
    yield put(uploadFile(_object_spread_props(_object_spread({}, payload), {
        onSuccess: function*() {
            yield delay(1000); // wait arbitrary 1s for stash to update
            yield put(reloadStashStream());
        }
    })));
}
function* uploadFileSaga({ payload }) {
    const folderId = payload.folderId || (yield select(getCurrentFolderId));
    yield call(uploadFileHandler, _object_spread_props(_object_spread({}, payload), {
        folderId
    }));
}
export default uploadFileSaga;

//# sourceMappingURL=uploadFile.js.map